<div
  #dropdownNotifications="bs-dropdown"
  class="dropdown d-inline-block mx-3"
  dropdown
  [insideClick]="true"
  [isOpen]="false"
  (onShown)="onDropdownShown()"
  (onHidden)="onDropdownHidden()"
>
  <button
    type="button"
    class="btn header-item noti-icon"
    id="page-header-notifications-dropdown"
    dropdownToggle
    aria-haspopup="true"
    [attr.aria-expanded]="isNotificationsOpen"
    [attr.aria-label]="notificationsAriaLabel"
  >
    <i class="bx bxs-bell" aria-hidden="true"></i>

    <span
      class="badge bg-danger rounded-pill"
      *ngIf="unreadTotal$ | async as total"
      aria-hidden="true"
    >
      {{ total }}
    </span>
  </button>
  <div
    class="notifications-panel dropdown-menu dropdown-mega-menu-xl dropdown-menu-end p-0"
    aria-labelledby="page-header-notifications-dropdown"
    *dropdownMenu
  >
    <div class="card h-100 m-0">
      <div class="card-header">
        <div class="row align-items-center">
          <div class="col">
            <h6 class="m-0">Notifications</h6>
          </div>
          <div class="col-auto">
            <button type="button" class="btn btn-sm p-2" (click)="dropdownNotifications.hide()">
              <i class="bx bx-x font-size-24 lh-1"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="card-body d-flex flex-column justify-content-end">
        <ngx-simplebar class="overflow-x-hidden simplebar-notifications" #scrollRef>
          <div class="row">
            <div class="col-auto">
              <button
                type="button"
                class="btn"
                [ngClass]="{
                  'btn-primary': !onlyUnread,
                  'btn-soft-primary': onlyUnread,
                }"
                (click)="onlyUnread = false"
              >
                All Notifications
              </button>
            </div>
            <div class="col-auto">
              <button
                type="button"
                class="btn"
                [ngClass]="{
                  'btn-primary': onlyUnread,
                  'btn-soft-primary': !onlyUnread,
                }"
                (click)="onlyUnread = true"
              >
                Only Unread
              </button>
            </div>
          </div>

          <div class="row mt-3">
            <div class="col-12">
              <div
                class="card border shadow-none mb-3"
                *ngFor="let item of getNotifications() | async | slice: 0 : 5"
              >
                <div class="card-body" *ngIf="item | communityEventNotificationChrome as chrome">
                  <div class="d-flex gap-2 align-items-center flex-wrap">
                    <span class="badge badge-soft-warning" *ngIf="!item.readInd"> Unread </span>
                    <ng-container *ngIf="chrome.applyR7; else legacyBadges">
                      <span *ngFor="let badge of chrome.badges" [class]="badge.cssClass">
                        {{ badge.label }}
                      </span>
                      <span class="text-muted font-size-14" *ngIf="chrome.sourceLabel">
                        {{ chrome.sourceLabel }}
                      </span>
                    </ng-container>
                    <ng-template #legacyBadges>
                      <span
                        class="badge bg-danger"
                        *ngIf="item.type === 'BROADCAST' && item.model?.priorityUrgentInd"
                      >
                        Urgent
                      </span>
                      <span class="badge badge-soft-primary" *ngIf="item.type === 'USER_EVENT'">
                        Custom Event
                      </span>
                    </ng-template>
                  </div>
                  <div class="row mt-2 align-items-center">
                    <div class="col">
                      <ng-container *ngIf="item.type === 'BROADCAST'; else default">
                        <h5 class="fw-bolder">
                          {{
                            item.model?.priorityUrgentInd === true
                              ? 'Urgent Broadcast'
                              : 'Broadcast'
                          }}
                        </h5>

                        <h6 class="text-primary">
                          {{ item.content.title }}
                        </h6>
                        <p class="col paragraph-truncate lines-2 m-0">
                          {{ item.content.body }}
                        </p>
                      </ng-container>

                      <ng-template #default>
                        <h5 class="fw-bolder mb-1">
                          {{ item.content.title }}
                        </h5>
                        <h6 class="text-primary mb-1" *ngIf="chrome.eventName">
                          {{ chrome.eventName }}
                        </h6>
                        <p class="col paragraph-truncate lines-2 m-0">
                          {{ item.content.body }}
                        </p>
                      </ng-template>
                    </div>
                    <div
                      class="col-auto"
                      *ngIf="item.type === 'CommunityEvent' && chrome.canSeeDetails"
                    >
                      <button type="button" class="btn text-primary" (click)="onDetails(item)">
                        See details
                        <i class="bx bx-chevron-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ngx-simplebar>
      </div>
      <div class="card-footer">
        <div class="row">
          <div class="col">
            <button
              class="btn btn-sm btn-primary font-size-14 text-center w-100"
              (click)="onNotifications()"
            >
              <i class="bx bx-chevron-right"></i>
              <span> Go to all Notifications </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
